import {Component, OnInit, ViewChild} from '@angular/core';
import {
  CreateMinilienGQL,
  CreateMinilienMutationVariables,
  GetMinilienListingGQL,
  GetMinilienListingQueryVariables,
  UpdateMinilienGQL,
  UpdateMinilienInput,
  UpdateMinilienMutationVariables
} from "../../../graphql/generated";
import {map} from "rxjs";
import {extractEdgesAndNodes} from "../graphql/operators/extract-edges-and-nodes";
import {Table} from "primeng/table";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {v4 as uuidv4} from 'uuid';
import {MessageService} from "primeng/api";
import {UserService} from "../services/user.service";
import {AppComponent} from "../app.component";
import {DegradedModeService} from "../services/degraded-mod-service";

@Component({
  selector: 'app-miniliens',
  templateUrl: './miniliens.component.html',
  styleUrls: ['./miniliens.component.scss']
})


export class MiniliensComponent implements OnInit {
  miniliens: any
  totalRecords: any = 0

  dataLoaded: boolean = false
  loading: boolean = true
  @ViewChild('dt') table: Table;
  visible: boolean = false;

  form = new FormGroup({
    id: new FormControl(''),
    url_courte: new FormControl('', [Validators.required]),
    url_longue: new FormControl('', [Validators.required]),
  });
  submitted: boolean = false;
  errors: any[] = [];
  formType: string = 'create';
  ngOnInit(): void {
  }

  constructor(
    private service: GetMinilienListingGQL,
    private createMinilienService: CreateMinilienGQL,
    private updateMinilienService: UpdateMinilienGQL,
    private messageService: MessageService,
    public userService: UserService,
    public degradedModeService: DegradedModeService
  ) {}

  clear(table: Table) {
    table.clear();
    // this.filter.nativeElement.value = '';
  }

  loadMiniliens() {
    this.service.watch().valueChanges.pipe(
      map(result => result.data.getMinilienListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          this.miniliens = value
          this.dataLoaded = true
          this.loading = false
        },
        error: err => {
        }
      }
    )
  }

  showDialog() {
    this.visible = true;
    this.formType = 'create'
  }

  onSubmit(): void {
    this.submitted = true;
    this.errors = []

    if (this.form.valid) {
      var urlCourte = this.form.get('url_courte')!.value
      var urlLongue = this.form.get('url_longue')!.value
      var id = this.form.get('id')!.value

      var input = {}
      input['url_courte'] = urlCourte;
      input['url_longue'] = urlLongue;
      this.service.fetch({filter: JSON.stringify({url_courte: urlCourte})})
        .subscribe({
          next: (result) => {
            var canUpdate = true;
            if (result.data.getMinilienListing) {
              const totalCount = result.data.getMinilienListing.totalCount
              if (totalCount && totalCount > 0) {
                if (id?.trim() !== null && id !== '') { // Si c'est une modification on verifie que l'id remonté est différent de celui en cours pour bloquer
                  if (result.data.getMinilienListing.edges) {
                    result.data.getMinilienListing.edges.forEach((edge) => {
                      if(edge?.node?.id){
                        if(edge.node.id !== id){
                          canUpdate = false;
                          this.messageService.add({
                            key: 'messages',
                            severity: 'error',
                            summary: "Url courte déjà utilisée dans le minilien " + edge.node.id
                          });
                        }
                      }
                    });
                  }
                } else {
                  canUpdate = false;
                  this.messageService.add({
                    key: 'messages',
                    severity: 'error',
                    summary: "Url courte déjà utilisée dans un autre minilien"
                  });
                }
              }
            }
            if (canUpdate) {
              // Accepter la création ou la modification
              if (id !== '' && id !== null) {
                const variables: UpdateMinilienMutationVariables = {
                  id: parseInt(id),
                  input: input
                }

                this.updateMinilienService.mutate(variables).subscribe({
                  next: value => {
                    this.loadMiniliens()
                    this.resetForm()
                    this.messageService.add({key: 'messages', severity: 'success', summary: "Minilien mis à jour"});
                  },
                  error: err => {
                    if (err.error.message) {
                      this.messageService.add({key: 'messages', severity: 'error', summary: err.error.message});
                      // this.errors.push(err.error.message)
                      // this.successMessage = ''
                    }
                    if (err.error.detail) {
                      this.messageService.add({key: 'messages', severity: 'error', summary: err.error.detail});
                      // this.errors.push(err.error.detail)
                      // this.successMessage = ''
                    }
                  }
                });
              } else {
                const variables: CreateMinilienMutationVariables = {
                  key: uuidv4(),
                  input: input
                }

                this.createMinilienService.mutate(variables).subscribe({
                  next: value => {
                    this.loadMiniliens()
                    this.resetForm()
                    this.messageService.add({key: 'messages', severity: 'success', summary: "Minilien créé"});
                  },
                  error: err => {
                    if (err.error.message) {
                      this.messageService.add({key: 'messages', severity: 'error', summary: err.error.message});
                      // this.errors.push(err.error.message)
                      // this.successMessage = ''
                    }
                    if (err.error.detail) {
                      this.messageService.add({key: 'messages', severity: 'error', summary: err.error.detail});
                      // this.errors.push(err.error.detail)
                      // this.successMessage = ''
                    }
                  }
                });
              }
            }
          }
        });
    }
  }

  editMinilien(
    id,
    urlCourte,
    urlLongue
  ) {
    this.form.controls['url_courte'].setValue(urlCourte)
    this.form.controls['url_longue'].setValue(urlLongue)
    this.form.controls['id'].setValue(id)

    this.visible = true
    this.formType = 'edit'
  }

  resetForm() {
    this.form.reset()
    this.visible = false
  }

  loadDatas($event) {

    var filters = $event.filters;
    var keepedFilters = {};
    for (const key in filters) {
      if (filters[key].value !== null && filters[key].value !== '') {
        var extractedValue = this.extraireFiltres(key);
        if (extractedValue !== null) {
          keepedFilters[extractedValue] = filters[key].value;
        }
      }
    }

    var filterJson = {};
    for (const keepedFilter in keepedFilters) {
      filterJson[keepedFilter] = {}
      filterJson[keepedFilter]['$like'] = '%' + keepedFilters[keepedFilter] + '%'
    }

    var filterString = Object.entries(filterJson).length > 0 ? JSON.stringify(filterJson) : null

    const variables: GetMinilienListingQueryVariables = {
      first: $event.rows,
      after: $event.first,
      filter: filterString
    }

    var datas = this.service.watch(variables).valueChanges

    datas.pipe(
      map(result => result)
    ).subscribe({
        next: value => {
          this.totalRecords = value.data.getMinilienListing ? value.data.getMinilienListing.totalCount : 0;
        },
        error: err => {

        }

      }
    )

    datas.pipe(
      map(result => result.data.getMinilienListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          this.miniliens = value
          this.dataLoaded = true
          this.loading = false
        },
        error: err => {
        }
      }
    )
  }

  private extraireFiltres(chaine) {
    // Découper la chaîne en un tableau en utilisant le point comme séparateur
    const parties = chaine.split('.');

    // Initialiser les variables table et champ
    let table = "";
    let champ = "";

    if (parties.length >= 2) {
      // Récupérer les deux dernières parties
      table = parties[parties.length - 2];
      champ = parties[parties.length - 1];

      return table + '.' + champ
    } else if (parties.length === 1) {
      champ = parties[parties.length - 1];
      // Si la chaîne contient une seule partie, la mettre dans champ
      return champ
    }

    return null;
  }
}
